/*
 * Scenario: long-review
 *
 * 20 Rewrites in einer Schleife — Stress-Test fuer:
 *   - EditorView._rebuildLines: laeuft pro setReviewHint einmal voll durch.
 *     Bei 20 Composites mit jeweils LCS-Diff ist das messbar; im Browser
 *     muss das Scrollen + Toggle T spuerbar bleiben.
 *   - ReviewController._suggestions als Array — keine Quadrat-Aufwaende
 *     in den Find-/Sync-Pfaden.
 *   - reviewHeartbeat-Stub: ReviewController._startHeartbeat ruft
 *     transport.reviewHeartbeat() alle 60 s. Im Browser nicht beobachtbar
 *     in einer kurzen Sitzung; im Test pruefen wir nur, dass die Methode
 *     wenn vorhanden ohne Fehler aufgerufen wird.
 *
 * Falls das Dokument keine 20 Text-Paragraphen hat, machen wir so viele
 * wie verfuegbar — Performance-Aussage haengt am verwendeten Test-
 * Dokument.
 */

import { emit, wait } from './_helpers.js'

export const name = 'long-review'
export const description = '20 small rewrites in a row — performance check.'

export async function run(state) {
    await emit(state, 'session', { sessionId: 'mock-long-review' }, 0)
    await emit(state, 'thinking', { text: 'I have a long list — small polishes across the document.' }, 200)
    await emit(state, 'thinkingDone', {}, 150)

    const paras = state.context?.cursorContext?.textParagraphs || []
    if (paras.length === 0) {
        await emit(state, 'delta', { text: 'No text paragraphs to polish.' }, 100)
        await emit(state, 'done', { usage: {} }, 100)
        return
    }
    const count = Math.min(20, paras.length)
    const toolCallIds = []
    // Bewusst kurze Delays — der Performance-Test zaehlt das Rendering, nicht
    // die Emit-Latenz. Im Browser sollten alle 20 Composites simultan da sein.
    for (let i = 0; i < count; i++) {
        const p = paras[i]
        const toolCallId = `tu_lr_${i}_${Date.now().toString(36)}`
        toolCallIds.push(toolCallId)
        await emit(state, 'proposeRewrite', {
            toolCallId,
            paragraphId: p.id,
            baseVersion: typeof p.version === 'number' ? p.version : undefined,
            originalText: p.text,
            // Minimal-Diff: vorne ein Ausrufezeichen davor — provoziert
            // genau eine add-Range, der Rest bleibt common. Schnell zu
            // diffen, aber sichtbar.
            newText: '! ' + p.text,
            reason: 'Trivial polish — performance probe.'
        }, 50)
    }
    await emit(state, 'done', { usage: {} }, 100)

    try {
        const results = await Promise.all(toolCallIds.map(id => wait(state, id, 5 * 60 * 1000)))
        const applied = results.filter(r => r.result === 'applied').length
        await emit(state, 'delta', { text: `Done. ${applied} of ${count} accepted.` }, 200)
        await emit(state, 'done', { usage: {} }, 100)
    } catch { /* abort */ }
}
